module.exports = __webpack_public_path__ + "media/bootstrap-icons/envelope-open-1d452dae.svg";